import PropTypes from 'prop-types';
import { ChildrenPropType } from '../../../../../prop-types/children';
import { useWalletRegistrationModalContext } from '../../contexts/wallet-registration-modal-context';

export const RequirementGuard = ({ children, requirements }) => {
  const { requiredForms } = useWalletRegistrationModalContext();

  const safeRequirements = typeof requirements === 'string' ? [requirements] : requirements;
  const shouldShowContent = safeRequirements.some((requirement) => requiredForms?.includes(requirement));

  if (!shouldShowContent) {
    return null;
  }

  return children;
};

RequirementGuard.propTypes = {
  children: ChildrenPropType.isRequired,
  requirements: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]).isRequired,
};
